import {
  createKpiTileItem,
  checkForNA,
  appendPercentage,
  formatValueWithMiddlewares,
  applySuffix,
} from '@v2/utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { applicationErrors, applicationErrorsDelta } = data;
    return createKpiTileItem(
      'Application Errors',
      formatValueWithMiddlewares(Math.abs(applicationErrors), [
        checkForNA,
        applySuffix,
      ]).toString(),
      applicationErrorsDelta
        ? {
            isPositiveValue: applicationErrorsDelta <= 0,
            text: formatValueWithMiddlewares(Math.abs(applicationErrorsDelta), [
              checkForNA,
              appendPercentage,
            ]).toString(),
            sideLabel: '',
            showArrow: applicationErrorsDelta !== 0,
          }
        : []
    );
  },
};
